<div mat-dialog-title>
    {{'Unread Chat' | translate}}
</div>
<div mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="1vh">
        <div fxFlex *ngFor="let message of data.unread">
            <div *ngIf="message.caseId" (click)="gotoCase(message)" class="link">
                <ng-container *ngIf="message.count == 1">
                    <span class="number">{{message.count}}</span> {{ 'unread message from Y in case Z' | translate: {
                    sender: message.displayName,
                    case: message.caseName
                    } }}
                </ng-container>
                <ng-container *ngIf="message.count > 1">
                    <span class="number">{{message.count}}</span> {{ 'unread messages from Y in case Z' | translate: {
                    sender: message.displayName,
                    case: message.caseName
                    } }}
                </ng-container>
            </div>
            <div *ngIf="!message.caseId" (click)="gotoInvestigator(message)" class="link">
                <ng-container *ngIf="message.count == 1">
                    <span class="number">{{message.count}}</span> {{ 'unread message from Y' | translate: {
                    sender: message.displayName
                    } }}
                </ng-container>
                <ng-container *ngIf="message.count > 1">
                    <span class="number">{{message.count}}</span> {{ 'unread messages from Y' | translate: {
                    sender: message.displayName
                    } }}
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <div fxLayout="row" fxFlex fxLayoutGap="0px">
        <div fxFlex align="right">
            <button mat-raised-button mat-dialog-close>
                {{ "Close" | translate }}
            </button>
        </div>
    </div>
</div>